import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { addOrRemove } from 'common/src/util/array';
import { isNonEmptyString } from 'common/src/util/string';
import { PossibleColumn } from 'common/src/vo/segment';
import * as React from 'react';
import { Button } from '../designSystem/components/button';
import { CheckboxText } from '../designSystem/components/checkbox';
import { Dropdown } from '../designSystem/components/dropdown/dropdown';
import { Menu } from '../designSystem/components/dropdown/menu';
import { Trigger } from '../designSystem/components/dropdown/trigger';
import { TextInput } from '../designSystem/components/textInput';
import { useHeavent } from '../hooks/useHeavent';
import { useFiltersColumnsContext } from './filtersColumnsContext';

interface IFiltersColumnsSearchRowSearchColumnsDropdownProps {
    searchableColumns: PossibleColumn[];
}

export const FiltersColumnsSearchRowSearchColumnsDropdown = (
    props: IFiltersColumnsSearchRowSearchColumnsDropdownProps
) => {
    const { translate } = useHeavent();
    const { columnsSearch, setColumnsSearch } = useFiltersColumnsContext();
    const [search, setSearch] = React.useState('');
    const searchableColumns = React.useMemo(() => {
        if (isNonEmptyString(search)) {
            return props.searchableColumns.filter((c) =>
                c.name.toLowerCase().trim().includes(search.toLowerCase().trim())
            );
        } else {
            return props.searchableColumns;
        }
    }, [props.searchableColumns, search]);

    return (
        <Dropdown>
            <Trigger>
                <Button
                    color="white"
                    css={{
                        borderLeft: 'none',
                        borderBottomLeftRadius: '0',
                        borderTopLeftRadius: '0'
                    }}
                    leftIcon="bars-filter"
                />
            </Trigger>

            <Menu css={{ padding: '0' }} maxHeight={350} placement="bottom-end" width={320}>
                <Flex css={{ padding: '$4 $6' }} direction="column" gap="3">
                    <Box font="gray800 textMd medium">{translate('rechercher_sur_85243')}</Box>

                    <TextInput
                        icon="magnifying-glass"
                        placeholder={translate('filtrer_78031')}
                        state="search"
                        value={search}
                        onChange={setSearch}
                    />

                    <Flex direction="column" gap="3">
                        {searchableColumns.map(({ slug, name }) => (
                            <CheckboxText
                                key={slug}
                                state={columnsSearch.includes(slug) ? 'checked' : 'unchecked'}
                                onClick={(state) => {
                                    setColumnsSearch(
                                        addOrRemove(columnsSearch, slug, state === 'checked')
                                    );
                                }}
                            >
                                {name}
                            </CheckboxText>
                        ))}
                    </Flex>
                </Flex>
            </Menu>
        </Dropdown>
    );
};
